module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAcBAMAAABrFHmkAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAwUExURUdwTPttAfptAfpsAfttAftuAP1tAPptAfptAf9sAP9vAPptAftuAfttAflvAPtuAuH3c/8AAAAPdFJOUwDfgmCiQCC/byEQ71DPMN5WFAYAAAC1SURBVBjTY2DABiKUgQRrkwGMz/T/vxgDg/7/jwlQgfc7Qr4zMH9s9S+ACugbMNQ3JH5jWP0BKuB/gCF/l74DA+8vqEB/FQP7H/kEBnsBqMDajwY8f78zLPp/AMTjOmxssf9jx8fvJvu/GBsfY2Bg/I8CDBjiLymBgD+EAhod7wA2B0rNL0ATyMcmsFEQBOShVAHDQlRbFBgY7BUQWvhBbh28ApozgeC8WxoQ5IME4pG9UsAAAADAbMydnzgFAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/membership/gift.png
// module id = 1801
// module chunks = 0